import { render, staticRenderFns } from "./ShopList.vue?vue&type=template&id=70af1d5d&scoped=true&"
import script from "./ShopList.vue?vue&type=script&lang=js&"
export * from "./ShopList.vue?vue&type=script&lang=js&"
import style0 from "./ShopList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ShopList.vue?vue&type=style&index=1&id=70af1d5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70af1d5d",
  null
  
)

export default component.exports